import ConversationStep from "./ConversationStep";
import QuestionStep from "./QuestionStep/QuestionStep";
import { FC } from "react";
import { CourseTabComponentProps } from "@vixi/types";
import { CourseConversation, CourseData } from "@vixi/types";
import { STEP_TYPE } from "@vixi/types";

export interface CourseStepContentProps extends CourseTabComponentProps {
  content: CourseData.Step;
}

/**
 * @param props.path should resemble: ["chapters", index, "lessons", index, "steps", index]
 */
export const CourseStepContent: FC<CourseStepContentProps> = ({
  path,
  content,
  ...props
}: CourseStepContentProps) => {
  switch (content?.type) {
    case STEP_TYPE.CONVERSATION:
      return <ConversationStep {...(content as CourseConversation)} path={path} />;
    case STEP_TYPE.MCQ:
    case STEP_TYPE.FITB:
    case STEP_TYPE.MATCHING:
      return <QuestionStep {...content} path={path} />;
    default:
      return <h4 className="text-error">Invalid step type ({JSON.stringify(props)})</h4>;
  }
};
